import styled from 'styled-components';
import { StyledListItem } from '../list-item/styled';
import { Body2Styles } from '../typography';
import { getSizeBy, getColorShade } from '../../../src/styled/utils';
import { BorderBottom } from '../../../src/styled/shared-styles';
export const StyledListSubheader = styled(StyledListItem) `
  ${Body2Styles};
  ${BorderBottom};
  padding: ${getSizeBy(3)};
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
`;
